var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1875 19.4125V5.5875C11.1875 4.275 10.6275 3.75 9.23625 3.75H5.70125C4.31 3.75 3.75 4.275 3.75 5.5875V19.4125C3.75 20.725 4.31 21.25 5.70125 21.25H9.23625C10.6275 21.25 11.1875 20.725 11.1875 19.4125Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 9.455V5.4825C21.25 4.24875 20.69 3.75 19.2988 3.75H15.7637C14.3725 3.75 13.8125 4.24875 13.8125 5.4825V9.44625C13.8125 10.6888 14.3725 11.1787 15.7637 11.1787H19.2988C20.69 11.1875 21.25 10.6888 21.25 9.455Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 19.2988V15.7637C21.25 14.3725 20.69 13.8125 19.2988 13.8125H15.7637C14.3725 13.8125 13.8125 14.3725 13.8125 15.7637V19.2988C13.8125 20.69 14.3725 21.25 15.7637 21.25H19.2988C20.69 21.25 21.25 20.69 21.25 19.2988Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDash);
export default __webpack_public_path__ + "static/media/dash.d138c0e9fc00cc562bee1ae1f352cb6d.svg";
export { ForwardRef as ReactComponent };